import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ProductType } from "@obg/core.config";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { filter, map, tap } from "rxjs/operators";

import { APP_CONTEXT_ACTION_TYPE } from "../app-context/app-context.action";

import { LastVisitedProductService } from "./last-visited-product.service";

@Injectable()
export class LastVisitedProductEffect {
	saveProductType$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(APP_CONTEXT_ACTION_TYPE.setProduct),
				map((x: ActionWithPayload<ProductType>) => x.payload),
				filter((productType) => this.service.getProductType() !== productType),
				tap((productType) => this.service.setProductType(productType))
			),
		{ dispatch: false }
	);

	constructor(
		private actions$: Actions,
		private service: LastVisitedProductService
	) {}
}
